"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _input = _interopRequireDefault(require("./input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InputOnBlur extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      pendingUpdate: false,
      value: null,
      message: null,
      messageType: null
    });
    _defineProperty(this, "_hasChanged", value => {
      if (this.props.type === 'RichText') {
        return value.__html !== this.props.value.__html;
      }
      return '' + value !== '' + this.props.value;
    });
    _defineProperty(this, "_getValue", () => {
      return this.state.pendingUpdate ? this.state.value : this.props.value;
    });
    _defineProperty(this, "_onChange", value => {
      this.setState({
        pendingUpdate: true,
        value
      });
    });
    _defineProperty(this, "_getValidationMessage", () => {
      const validation = {
        message: '',
        messageType: null
      };
      if (this.props.customValidation) {
        validation.message = this.props.customValidation(this._getValue()) || '';
        validation.messageType = validation.message ? this.props.customValidationType || 'Error' : null;
      }
      return validation;
    });
    _defineProperty(this, "_validateAndReportChangedValue", () => {
      if (this.state.pendingUpdate) {
        let value = this.state.value;
        switch (this.props.type) {
          case 'Year':
            if (value !== null) {
              // use current year as cutoff for deciding on century
              // not concerned here about slight discrepancies resulting from time zones
              // as it's mainly about calculating year of birth
              const cutOff = '' + new Date().getFullYear();
              const century1 = cutOff.substr(0, 2);
              const century0 = +century1 - 1 + '';
              if (value.length === 2) {
                if (+(century1 + value) < +cutOff) {
                  value = century1 + value;
                } else value = century0 + value;
              }
              value = +value;
            }
            break;
          case 'Time':
            if (value) {
              if (/^\d$/.exec(value)) {
                if (+value > 5) {
                  value = '0' + value + ':00:00';
                } else value = +value + 12 + ':00:00';
              } else if (/^\d\d$/.exec(value)) {
                value = value + ':00:00';
              } else if (value.substr(-1) === ':') value = value + '00';
            }
            break;
          default:
            break;
        }
        if (this._hasChanged(value)) this.props.onChange(value, this.props.name);
      }

      // For editable fields set need to mark as not editing
      if (this.props.onBlur) this.props.onBlur();
    });
    _defineProperty(this, "_onBlur", () => {
      this._validateAndReportChangedValue();
    });
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.pendingUpdate && this.props.value !== nextProps.value) {
      this.setState({
        pendingUpdate: null,
        value: null
      });
    }
  }
  componentWillUnmount() {
    this._validateAndReportChangedValue();
  }
  render() {
    // ref set to input is then used for editable fields

    return /*#__PURE__*/_react.default.createElement(_input.default, _extends({}, this.props, this._getValidationMessage(), {
      value: this._getValue(),
      onChange: this._onChange,
      onBlur: this._onBlur,
      ref: this.props.setInput
    }));
  }
}
exports.default = InputOnBlur;